// prop-types is a library for typechecking of props
import PropTypes from 'prop-types'

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import SoftInput from 'components/SoftInput'
import { IconButton, Tooltip, Fade, TextField } from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'
import { useFieldState } from 'hooks/useFieldState'
function FormField({
  label,
  required,
  tooltip,
  type,
  defaultErrorState,
  forceError,
  onBlur,
  ref,
  ...rest
}) {
  const validateDate = (value) => {
    console.log('validate date running')
    return `${value}`.match(/^(?!0{1,3}\d)\d{4}-\d{2}-\d{2}$/)
  }
  const validateInt = (value) => {
    console.log('validate int running')
    return `${value}`.match(/^\d+(\.\d{1,2})?$/)
  }
  const validateEmail = (value) => {
    console.log('validate email running')
    return `${value}`.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
  }
  const validateString = (value) => {
    // check if it's too long
    const str = `${value}`
    if (str.length > 1024) return false
    return true
  }
  const validatorFunction =
    type === 'text'
      ? validateString
      : type === 'email'
      ? validateEmail
      : type === 'date'
      ? validateDate
      : validateInt
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    defaultErrorState,
    validatorFunction,
    forceError,
  })
  const handleOnblurWithValidation = (e) => {
    let value = e.target.value
    if (type === 'text') value = value.trim()
    const isValid = validatorFunction(value)
    handleOnblur?.(value)
    if (isValid) {
      onBlur?.(value)
    }
  }
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      justifyContent="flex-end"
      height="auto"
    >
      <SoftBox ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography
          component="label"
          variant="body2"
          fontWeight="regular"
          textTransform="capitalize"
        >
          {label}
          {required ? <span style={{ color: 'red' }}> *</span> : null}
          {tooltip?.title ? (
            <Tooltip
              TransitionComponent={Fade}
              title={tooltip.title}
              placement="top"
              color="info"
              enterTouchDelay={0}
              leaveTouchDelay={3000}
              {...tooltip.overrides}
            >
              <IconButton size="small" color="dark">
                <HelpIcon sx={{ marginTop: '-6px' }} />
              </IconButton>
            </Tooltip>
          ) : null}
        </SoftTypography>
      </SoftBox>
      <SoftInput
        error={isError}
        success={isSuccess}
        autoComplete="off"
        data-1p-ignore
        onBlur={handleOnblurWithValidation}
        required={required}
        type={type}
        inputRef={ref}
        {...rest}
      />
    </SoftBox>
  )
}

// Setting default values for the props of FormField
FormField.defaultProps = {
  label: ' ',
}

// Typechecking props for FormField
FormField.propTypes = {
  label: PropTypes.string,
  tooltip: PropTypes.shape({ title: PropTypes.string.isRequired }),
  forceError: PropTypes.bool,
}

export default FormField
